export const TERMS_AND_CONDITIONS_LINK_FALLBACK =
	'https://www.multichoice.com/multichoice-africa-subscriber-ts-cs-overview-sa.php'
